import React, { useEffect, useState } from 'react';
import SiteSelector from '../../siteSelector';
import CustomInput from '../../customInput';
import IconButton from '../../iconButton';

const AddFunnelSteps = ({ sites, onSelectionChange, availableSites }) => {
  const [selectedSites, setSelectedSites] = useState(sites || {});

  useEffect(() => {
    onSelectionChange(parseSelectedSitesObject());
  }, [selectedSites]);

  const parseSelectedSitesObject = () => {
    return [1, 2, 3, 4, 5]
      .map(stepNum => {
        const site = selectedSites[`step${stepNum}`];
        return site
          ? { id: site.value, displayName: site.displayName, stepName: site.stepName || site.displayName }
          : null;
      })
      .filter(Boolean);
  };

  const onSelection = (site, step) => {
    setSelectedSites(prev => {
      // Find if the site is already selected in another step
      const prevStep = Object.keys(prev).find(k => prev[k]?.value === site.id && k !== step);
      let newSelected = {
        ...prev,
        [step]: {
          label: `${site?.displayName} - ${site?.id}`,
          value: site.id,
          displayName: site?.displayName,
          id: site.id,
          stepName: prev[step]?.stepName || ''
        }
      };
      if (prevStep) {
        // Remove the previous step where this site was selected
        delete newSelected[prevStep];
      }
      return newSelected;
    });
  };

  const onStepNameChange = (step, name) => {
    setSelectedSites(prev => {
      const prevStep = prev[step] || {};
      return {
        ...prev,
        [step]: {
          label: prevStep.label || 'Select site',
          value: prevStep.value ?? null,
          displayName: prevStep.displayName,
          id: prevStep.id,
          stepName: name
        }
      };
    });
  };

  // Determine how many selectors to show
  // Show up to the highest filled step + 1, always at least 2, max 5
  const filledSteps = [1, 2, 3, 4, 5].filter(
    i => selectedSites[`step${i}`] && (selectedSites[`step${i}`].value || selectedSites[`step${i}`].stepName)
  );
  let visibleSteps = Math.max(2, Math.min(filledSteps.length ? Math.max(...filledSteps) + 1 : 2, 5));

  return (
    <div className="add-funnel-steps">
      {[1, 2, 3, 4, 5].slice(0, visibleSteps).map(stepNum => (
        <div className="step" key={stepNum}>
          <label> Step {stepNum}</label>
          <div className="step-info">
            <div className="step-input">
              <div className="dropdown-label">Name</div>
              <CustomInput
                label={'Name your step'}
                type="text"
                isEditable={true}
                placeholder={'Write a name'}
                value={selectedSites[`step${stepNum}`]?.stepName || ''}
                onChange={e => onStepNameChange(`step${stepNum}`, e.target.value)}
              />
            </div>
            <div className="step-site">
              <SiteSelector
                onSelection={site => onSelection(site, `step${stepNum}`)}
                customSelected={selectedSites[`step${stepNum}`] || { label: 'Select site', value: null }}
                availableSites={availableSites}
              />
            </div>
            <div className="step-remove-button">
              <IconButton
                icon={'trash'}
                onPress={() => {
                  setSelectedSites(prev => {
                    // Remove the selected step and reindex the rest
                    const newSelected = { ...prev };
                    delete newSelected[`step${stepNum}`];
                    // Reindex steps to keep them sequential
                    const steps = [1, 2, 3, 4, 5]
                      .filter(i => newSelected[`step${i}`])
                      .map(i => newSelected[`step${i}`]);
                    const reindexed = {};
                    steps.forEach((site, idx) => {
                      reindexed[`step${idx + 1}`] = site;
                    });
                    return reindexed;
                  });
                }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddFunnelSteps;
